import { render } from "./IconInfoCircleClassicSolid.vue?vue&type=template&id=cb0364ce"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__